export const KERNEL_MIGRATION_SQL = `
CREATE TABLE kernel_metadata (
  key TEXT PRIMARY KEY NOT NULL,
  value_json TEXT NOT NULL,
  updated_at TEXT NOT NULL
) STRICT;
`;
//# sourceMappingURL=001_kernel.sql.js.map